var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "v-list",
        {
          attrs: {
            dense: ""
          }
        },
        [
          _c("v-subheader", [
            _vm._v(" Your security questions are set. Your questions are: ")
          ]),
          _c(
            "v-list-item-group",
            {
              attrs: {
                color: "primary"
              }
            },
            _vm._l(_vm.questions, function(item, i) {
              return _c(
                "v-list-item",
                {
                  key: i,
                  attrs: {
                    disabled: ""
                  }
                },
                [
                  _c(
                    "v-list-item-content",
                    [
                      _c("v-list-item-title", {
                        domProps: {
                          innerHTML: _vm._s(item)
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            }),
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "pt-3"
        },
        [
          _c(
            "gg-btn",
            {
              attrs: {
                color: "primary",
                tile: ""
              },
              on: {
                click: _vm.changeQuestions
              }
            },
            [_vm._v(" Change questions ")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }